import { Pipe, PipeTransform } from '@angular/core';

/**
 * 判斷一列明細是否可人工開立進貨單。
 * 已失效的明細不可開;落在 Sample 儲位的明細由排程自動產生 Sample AD,畫面仍列出並反灰,
 * 避免同一筆明細被人工與排程各產一張進貨單。
 * A detail row may be issued manually only when it is alive and not auto-advised by the scheduler.
 *
 * @param rowData 明細列;三種來源單據的明細 bean 只需具備這兩個旗標
 *                (any of the three source-document detail beans; only these two flags are read)
 */
export function isDetailIssuable(rowData: { aliveStatus?: string; autoAdvisingFlag?: string }): boolean {
  return rowData?.aliveStatus === 'Y' && rowData?.autoAdvisingFlag !== 'Y';
}

/**
 * 明細是否可人工開單的範本用管線。
 * 以 pure pipe 提供,讓同一列在多個欄位繪製時沿用同一次計算,不必每格呼叫元件方法。
 * Template-side form of the rule; a pure pipe reuses one result per row across bindings.
 */
@Pipe({
  name: 'detailIssuable'
})
export class DetailIssuablePipe implements PipeTransform {

  transform(rowData: { aliveStatus?: string; autoAdvisingFlag?: string }): boolean {
    return isDetailIssuable(rowData);
  }

}
